/* Gastrolux instant Shopify native collection filtering, no page reload */
(function(){
  if(window.__gweCollectionFacetsScript)return;
  window.__gweCollectionFacetsScript=true;
  let active=null;
  const instances=new WeakMap();
  function close(){
    if(!active)return;
    const s=active;
    active=null;
    s.portal.classList.remove('is-open');
    s.portal.setAttribute('aria-hidden','true');
    s.button.setAttribute('aria-expanded','false');
    document.body.classList.remove('gwe-facets-scroll-lock');
    if(s.button.isConnected)s.button.focus({preventScroll:true});
    setTimeout(()=>{if(!s.portal.classList.contains('is-open'))s.portal.hidden=true},290);
  }
  function open(s){
    if(active&&active!==s)close();
    active=s;
    s.portal.hidden=false;
    s.portal.setAttribute('aria-hidden','false');
    s.button.setAttribute('aria-expanded','true');
    document.body.classList.add('gwe-facets-scroll-lock');
    requestAnimationFrame(()=>{if(active!==s)return;s.portal.classList.add('is-open');s.closeButton.focus({preventScroll:true})});
  }
  function getFormUrl(s){
    const url=new URL(location.href);
    [...url.searchParams.keys()].forEach(key=>{if(key.startsWith('filter.')||key==='sort_by'||key==='page')url.searchParams.delete(key)});
    const formData=new FormData(s.form);
    for(const [key,value] of formData)if(String(value).trim())url.searchParams.append(key,String(value));
    return url;
  }
  function syncScroll(s,newDoc){
    const fresh=newDoc.querySelector('.gwe-facets-form .gwe-facets-panel__scroll');
    const existing=s.portal.querySelector('.gwe-facets-form .gwe-facets-panel__scroll');
    if(!fresh||!existing)return;
    const openLabels=[...existing.querySelectorAll('.gwe-facets-group[open] summary > span:first-child')].map(el=>el.textContent.trim());
    const position=existing.scrollTop;
    existing.innerHTML=fresh.innerHTML;
    existing.querySelectorAll('.gwe-facets-group').forEach(d=>{if(openLabels.includes(d.querySelector('summary > span:first-child')?.textContent.trim()))d.open=true});
    existing.scrollTop=position;
    const input=newDoc.querySelector('.gwe-facets-form [name="sort_by"]');
    const sort=s.form.querySelector('[name="sort_by"]');
    if(input&&sort)sort.value=input.value;
  }
  function render(s,doc,target,refreshForm){
    const srcSection=doc.querySelector('.gwe-main-collection-layout, .gwe-collection-merch-layout, [data-section-type="collection-template"]');
    const currentSection=s.root.closest('[data-section-type="collection-template"]');
    const freshList=srcSection?.querySelector('.product-list-container');
    const currentList=currentSection?.querySelector('.product-list-container');
    const freshRoot=srcSection?.querySelector('[data-gwe-facets-root]');
    if(!freshList||!currentList||!freshRoot)throw new Error('Grille introuvable dans la réponse Shopify');
    freshList.querySelectorAll('[data-cc-animate]').forEach(el=>{
      el.removeAttribute('data-cc-animate');
      el.removeAttribute('data-cc-animate-delay');
      el.removeAttribute('data-cc-animate-duration');
      el.style.removeProperty('opacity');
      el.style.removeProperty('visibility');
      el.classList.remove('cc-animate-init');
    });
    currentList.replaceWith(freshList);
    const total=freshRoot.querySelector('.gwe-facets-toolbar__total');
    if(total){const existingTotal=s.root.querySelector('.gwe-facets-toolbar__total');if(existingTotal)existingTotal.textContent=total.textContent;}
    const newCounter=freshRoot.querySelector('.gwe-facets-trigger__count');
    const oldCounter=s.root.querySelector('.gwe-facets-trigger__count');
    if(newCounter){if(oldCounter)oldCounter.textContent=newCounter.textContent;else s.button.appendChild(newCounter.cloneNode(true))}
    else if(oldCounter)oldCounter.remove();
    const newReset=freshRoot.querySelector('.gwe-facets-reset-inline');
    const oldReset=s.root.querySelector('.gwe-facets-reset-inline');
    if(newReset){if(oldReset)oldReset.replaceWith(newReset.cloneNode(true));else s.root.querySelector('.gwe-facets-toolbar__left')?.appendChild(newReset.cloneNode(true))}
    else oldReset?.remove();
    let pills=s.root.querySelector('.gwe-facets-pills');
    const freshPills=freshRoot.querySelector('.gwe-facets-pills');
    if(freshPills){if(pills)pills.replaceWith(freshPills.cloneNode(true));else s.root.querySelector('.gwe-facets-toolbar')?.after(freshPills.cloneNode(true))}
    else pills?.remove();
    if(refreshForm)syncScroll(s,doc);
    const buttonLabel=s.portal.querySelector('[data-gwe-facets-apply-label]');
    if(buttonLabel){const count=total?.textContent.trim()||'les produits';buttonLabel.textContent='Voir '+count}
    if(location.href!==target.toString())history.pushState({gweFacets:true},'',target);
    document.dispatchEvent(new CustomEvent('gwe:collection:updated',{detail:{url:target.toString()}}));
  }
  async function update(s,url,refreshForm=false){
    if(s.controller)s.controller.abort();
    const controller=new AbortController();
    s.controller=controller;
    const list=s.root.closest('[data-section-type="collection-template"]')?.querySelector('.product-list-container');
    if(list)list.setAttribute('data-gwe-facets-loading','');
    const apply=s.portal.querySelector('.gwe-facets-apply');
    if(apply)apply.setAttribute('aria-busy','true');
    try{
      const response=await fetch(url.toString(),{signal:controller.signal,credentials:'same-origin',headers:{'X-Requested-With':'XMLHttpRequest'}});
      if(!response.ok)throw new Error('Shopify: '+response.status);
      const html=await response.text();
      if(controller.signal.aborted)return;
      const doc=new DOMParser().parseFromString(html,'text/html');
      render(s,doc,url,refreshForm);
    }catch(err){
      if(err.name!=='AbortError'){console.error('Gastrolux filtres',err);let note=s.portal.querySelector('[data-gwe-facets-error]');if(!note){note=document.createElement('p');note.dataset.gweFacetsError='';note.setAttribute('role','alert');note.className='gwe-facets-empty';s.portal.querySelector('.gwe-facets-panel__footer')?.prepend(note)}note.textContent='Impossible de mettre à jour les résultats. Réessayez.';}
    }finally{
      if(s.controller===controller){s.controller=null;s.root.closest('[data-section-type="collection-template"]')?.querySelector('.product-list-container')?.removeAttribute('data-gwe-facets-loading');apply?.removeAttribute('aria-busy')}
    }
  }
  function setup(){
    document.querySelectorAll('[data-gwe-facets-root]').forEach(root=>{
      if(instances.has(root))return;
      const button=root.querySelector('[data-gwe-facets-open]');
      const portal=root.querySelector('[data-gwe-facets-portal]');
      if(!button||!portal)return;
      const form=portal.querySelector('form');
      if(!form)return;
      const s={root,portal,button,form,closeButton:portal.querySelector('.gwe-facets-close'),controller:null,debounce:null};
      instances.set(root,s);
      document.body.appendChild(portal);
      button.addEventListener('click',()=>active===s?close():open(s));
      portal.querySelectorAll('[data-gwe-facets-close]').forEach(el=>el.addEventListener('click',close));
      form.addEventListener('change',event=>{if(event.target.matches('input,select')){clearTimeout(s.debounce);s.debounce=setTimeout(()=>update(s,getFormUrl(s),true),110)}});
      form.addEventListener('input',event=>{if(event.target.matches('input[type="number"]')){clearTimeout(s.debounce);s.debounce=setTimeout(()=>update(s,getFormUrl(s),true),550)}});
      form.addEventListener('submit',event=>{event.preventDefault();update(s,getFormUrl(s),true).then(()=>close())});
      root.addEventListener('click',event=>{
        const a=event.target.closest('.gwe-facets-pill,.gwe-facets-reset-inline');
        if(!a)return;
        event.preventDefault();
        update(s,new URL(a.href,location.href),true);
      });
      portal.addEventListener('click',event=>{
        const a=event.target.closest('.gwe-facets-clear');
        if(!a)return;
        event.preventDefault();
        update(s,new URL(a.href,location.href),true);
      });
    });
  }
  document.addEventListener('keydown',event=>{
    if(!active)return;
    if(event.key==='Escape'){event.preventDefault();close();return}
    if(event.key!=='Tab')return;
    const nodes=[...active.portal.querySelectorAll('a[href],button:not([disabled]):not([tabindex="-1"]),input:not([disabled]),select:not([disabled]),summary')].filter(el=>el.getClientRects().length);
    if(!nodes.length)return;
    if(event.shiftKey&&document.activeElement===nodes[0]){event.preventDefault();nodes[nodes.length-1].focus()}
    else if(!event.shiftKey&&document.activeElement===nodes[nodes.length-1]){event.preventDefault();nodes[0].focus()}
  });
  let stickyRaf=null;
  function updateStickyTop(){
    stickyRaf=null;
    const header=document.getElementById('site-control');
    const bottom=header?header.getBoundingClientRect().bottom:0;
    document.documentElement.style.setProperty('--gwe-facets-top',Math.min(window.innerHeight,Math.max(0,bottom))+'px');
  }
  function scheduleStickyTop(){if(stickyRaf===null)stickyRaf=requestAnimationFrame(updateStickyTop)}
  window.addEventListener('scroll',scheduleStickyTop,{passive:true});
  window.addEventListener('resize',scheduleStickyTop,{passive:true});
  document.addEventListener('shopify:section:load',scheduleStickyTop);
  scheduleStickyTop();
  document.addEventListener('shopify:section:load',setup);
  window.addEventListener('popstate',()=>{
    document.querySelectorAll('[data-gwe-facets-root]').forEach(root=>{const s=instances.get(root);if(s)update(s,new URL(location.href),true)});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
})();
